// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav_NhVVm","next":"next_kdT7R","prev":"prev_161cw"};